import * as Y from 'yjs'
import {DATABASE_COLUMN_NAME_MAX_CHARS} from '../../../utils/constants'

/**
 * yjs data layout:
 * - rows: Array<RowId>
 * - columns: Array<ColumnId>
 * - columnMeta: Map<ColumnId, ColumnMeta>
 * - data: Map<RowId, Map<ColumnId, string>>
 *
 * Future:
 * - views: Array<ViewId>
 * - viewMeta: Map<ViewId, View>
 */

 



















const defaultColumnMeta = {
  name: 'New column',
  type: 'text'
}

const generateId = (_doc) => {
  return crypto.randomUUID()
}

export const getRows = (doc) => {
  return doc.getArray('rows')
}

export const getColumns = (doc) => {
  return doc.getArray('columns')
}

export const changeColumn = (doc, columnId, newMeta) => {
  const columnMeta = doc.getMap('columnMeta')
  columnMeta.set(columnId, {
    ...newMeta,
    name: newMeta.name.substring(0, DATABASE_COLUMN_NAME_MAX_CHARS)
  })
}

const insertColumnAt = (doc, index, meta = defaultColumnMeta) => {
  const id = generateId(doc)
  doc.transact(() => {
    changeColumn(doc, id, meta)
    const columns = doc.getArray('columns')
    columns.insert(index, [id])
  })
  return id
}

export const insertColumnBefore = (
  doc,
  columnId,
  meta = defaultColumnMeta
) => {
  const columns = doc.getArray('columns')
  const index = columns.toArray().indexOf(columnId)
  return insertColumnAt(doc, index, meta)
}

export const insertColumnAfter = (
  doc,
  columnId,
  meta = defaultColumnMeta
) => {
  const columns = doc.getArray('columns')
  const index = columns.toArray().indexOf(columnId)
  return insertColumnAt(doc, index + 1, meta)
}

export const appendColumn = (doc, meta = defaultColumnMeta) => {
  const id = generateId(doc)
  doc.transact(() => {
    changeColumn(doc, id, meta)
    const columns = doc.getArray('columns')
    columns.push([id])
  })
  return id
}

export const duplicateColumn = (doc, columnId) => {
  const id = generateId(doc)
  doc.transact(() => {
    const columnMeta = doc.getMap('columnMeta')
    const existingMeta = columnMeta.get(columnId)
    if (!existingMeta) {
      throw new Error(`Column meta not found for columnId: ${columnId}`)
    }
    columnMeta.set(id, {...existingMeta})

    const data = doc.getMap('data')
    data.forEach((value) => {
      const source = value.get(columnId)
      if (source !== undefined) {
        value.set(id, source)
      }
    })

    const columns = doc.getArray('columns')
    const index = columns.toArray().indexOf(columnId)
    columns.insert(index + 1, [id])
  })
  return id
}

export const deleteColumn = (doc, columnId) => {
  doc.transact(() => {
    const columns = doc.getArray('columns')
    const index = columns.toArray().indexOf(columnId)
    columns.delete(index, 1)

    const data = doc.getMap('data')
    data.forEach((row, key) => {
      if (row.delete) {
        row.delete(columnId)
      } else {
        console.warn('Invalid row data structure, expected Y.Map', key, row)
      }
    })
  })
}

export const appendRow = (doc, userId) => {
  const id = generateId(doc)
  doc.transact(() => {
    const rows = doc.getArray('rows')
    const data = doc.getMap('data')
    const row = new Y.Map()
    if (userId) {
      row.set('_createdBy', userId)
      row.set('_createdAt', Date.now())
    }
    data.set(id, row)
    rows.push([id])
  })
  return id
}

export const deleteRow = (doc, rowId) => {
  doc.transact(() => {
    const rows = doc.getArray('rows')
    const index = rows.toArray().indexOf(rowId)
    if (index !== -1) {
      rows.delete(index, 1)
    }

    const data = doc.getMap('data')
    data.delete(rowId)
  })
}
